<template>
  <main>
    <div class="row">
      <div class="col s12 l10 offset-l1 card-panel recargas">
        <div class="row center-align" style="margin-bottom: 0%;">
          <div class="page-title">
            <span>Recargas Agendadas</span>
          </div>
          <div>
            <div class=" page-title">{{ computedList.length }} registros</div>
          </div>


          <div class="row center-align" style="margin-bottom: 0%;">
            <div class="col s6 m3 offset-m3 l2 offset-l4 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align " @click="dateIni">
                <span
                    class="material-symbols-outlined btn-style color"
                    style="position: relative; top: 4px;"
                >today</span
                >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Inicial:</span
                >
              </div>
              <input
                  id="input-fecha-inicial"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>

            <div class="col s6 m3 l2 input-date" style="cursor: pointer;">
              <link
                  rel="stylesheet"
                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <div class="center-align" @click="dateFin">
                <span
                    class="material-symbols-outlined btn-style "
                    style="position: relative; top: 4px;"
                >event</span
                >
                <span
                    class="prefix"
                    style="font-size: 18px; width: 6rem; top: 0.2rem;"
                >Fecha Final:</span
                >
              </div>
              <input
                  id="input-fecha-final"
                  type="text"
                  class="datepicker center-align"
                  style="cursor: pointer;"
              />
            </div>
          </div>
        </div>

        <div>
          <div class="col s6 left-align"></div>
          <div class="col s6 right-align">
            <div
                class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="toggleFiltros"
                data-position="top"
                :data-tooltip="mostrarFiltros ? 'Ocultar Filtros' : 'Mostrar Filtros'"
            >
              <link
                  rel="stylesheet"

                  href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
              />
              <span 
              class="material-symbols-outlined btn-style" >
              {{ mostrarFiltros ? 'filter_alt' : 'filter_alt_off' }}
            </span>
            </div>
            <div
                class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                @click="generarExcel"
                data-position="top"
                data-tooltip="Generar Excel"
            >
              <i class="fa fa-file-excel-o " aria-hidden="true"></i>
            </div>
          </div>

          <div class="row" v-show="mostrarFiltros" v-if="!isAsec">
            <div class="column col s6 m6 l2 xl2" v-for="titulo in titulos">
              <div class="chips validate input-filtros" :id="titulo.llave">

                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
          <div class="row" v-show="mostrarFiltros" v-else>
            <div
                class="column col s10 m6 l4 xl3"
                v-for="titulo in titulosAsec"
                style="width: 14%"
            >
              <div class="chips validate input-filtros" :id="titulo.llave">
                <input
                    class="chip-input"
                    :id="'input-' + titulo.llave"
                    @focusout="handleFocusOut(titulo.llave)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 l10 offset-l1 card-panel">
        <div v-show="isGettingReports" class="progress barraMovimientos">
          <div class="indeterminate"></div>
        </div>
        <div v-show="!isGettingReports" class="barra-invisible"></div>

        <div class="row">
          <div class="table-responsive">
            <table class="striped">
              <thead >
              <tr>
                <th>#</th>
                <th v-for="titulo in titulos">{{ titulo.valor }}</th>
<!--                <th >Editar</th>-->
                <th >Recargar</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(movimiento, index) in agregar100">
                <td>{{index +1 }}</td>
                <td>{{ movimiento.insertedDate }}</td>
                <td>{{ movimiento.fileId }}</td>
                <td>{{ movimiento.insertedBy }}</td>
                <td>{{ movimiento.modifiedBy }}</td>
                <td class="icc-table">{{ movimiento.icc }}</td>
                <td>{{ movimiento.dn }}</td>
                <td>{{ movimiento.city }}</td>
                <td>{{ movimiento.carrier }}</td>
                <td>{{ movimiento.hasBeenRecharged }}</td>
                <td>{{ movimiento.rechargeDate }}</td>
                <td>{{ movimiento.rechargeAmount }}</td>
                <td>{{ movimiento.rechargeAccumulatedAmount }}</td>
                <td>{{ movimiento.rechargeProgramDate }}</td>
<!--                <td>-->
<!--                  <p class="center-align">-->
<!--                    <i v-if="isEdirt(movimiento)"-->
<!--                       class="fa fa-pencil-alt cursorOn"-->
<!--                       @click="editar(movimiento)"-->
<!--                       aria-hidden="true"-->
<!--                    ></i>-->
<!--                  </p>-->
<!--                </td>-->
                <td>
                  <p class="center-align" v-if="isRecharge(movimiento)" style="cursor: pointer" @click="recharge(movimiento)">
                    <i
                       class="material-icons  "

                       aria-hidden="true"
                    >phone_android</i>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

let filtros = {};
let copyTitulos = [];
import {mapState} from "vuex";
import {i18n} from "@/constantes";
import {creaExcelCam, getProgramadas, checkoutProgramadas, creaExcel} from "@/api/api";

export default {
  name: "recargasProgramadas",
  data() {
    return {
      showMessageRange: false,
      showMessageOld: false,
      mensaje: " ",
      movimientos: [],
      titulo: "Cargando...",
      titulos: [
        {llave: "insertedDate", valor: "Fecha de Subida"},
        {llave: "fileId", valor: "Archivo"},
        {llave: "insertedBy", valor: "Subudo por"},
        {llave: "modifiedBy", valor: "Actualizado por"},
        {llave: "icc", valor: "Icc"},
        {llave: "dn", valor: "DN"},
        {llave: "city", valor: "Cuidad"},
        {llave: "carrier", valor: "Compañia"},
        {llave: "hasBeenRecharged", valor: "Recargado"},
        {llave: "rechargeDate", valor: "Fecha de recarga"},
        {llave: "rechargeAmount", valor: "Monto"},
        {llave: "rechargeAccumulatedAmount", valor: "Monto acomulado"},
        {llave: "rechargeProgramDate", valor: "Programada para"},
      ],

      usuarios: [],
      plataforma: "0",
      usuarioSeleccionado: "0",
      fechaIni: "",
      fechaFin: "",
      isGettingReports: true,
      numeroDeFilas: "",
      encontrados: "Cargando...",
      chips: [],
      chipsOptions: {
        onChipAdd: this.addChip,
        onChipDelete: this.deleteChip,
      },
      datosRecibios: [],
      datosAMostrar: [],
      indexScroll: 1,
      mostrarFiltros: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      this.consultar();
      $(window).scroll(() => {
        if (
            $(document).height() <
            $(window).scrollTop() + $(window).height() + 50
        ) {
          this.indexScroll++;
        }
      });
    });
  },
  computed: {
    ...mapState(["isAdmin"]),
    computedList() {
      this.datosAMostrar = this.datosRecibios.slice();

      if (this.chips.length) {
        let auxChips = this.chips.slice();
        let chipsArray = [];
        while (auxChips.length) {
          let chip = auxChips[0];
          chipsArray.push(
              auxChips.filter((auxChip) => auxChip.key == chip.key)
          );
          auxChips = auxChips.filter((auxChip) => auxChip.key != chip.key);
        }
        let auxDatosAMostrar = this.datosAMostrar.slice();
        chipsArray.forEach((element) => {
          auxDatosAMostrar = auxDatosAMostrar.filter((item) => {
            return element.some((titulo) => {

              return item[titulo.key]
                  .toUpperCase()
                  .includes(titulo.value.toUpperCase());
            });
          });
        });
        this.datosAMostrar = auxDatosAMostrar;
        console.log("Termino");
        console.log(this.datosAMostrar.length);
      }
      return this.datosAMostrar;
    },
    agregar100() {
      return this.computedList.slice(0, 20 * this.indexScroll);
    },
  },
  methods: {
    generarExcel() {
      console.log("por generar excel loco");
      this.$store.commit("ponerBarra");

      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const fechas = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };
      console.log(`1132312321`);
      creaExcel(this.chips, "AGENDADAS", fechas)
          .then((response) => {
            this.$store.commit("quitarBarra");
            if (window.location.href.includes("recargasasec.com")) {
              console.log(process.env.NODE_ENV);

              window.location =
                  process.env.NODE_ENV == "productionCam"
                      ? `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            } else {
              window.location =
                  process.env.NODE_ENV === "production"
                      ? `https://recarga-te.com/excel?nombre=${response.data.nombreArchivo}`
                      : `http://localhost:8091/excel?nombre=${response.data.nombreArchivo}`;
            }
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
            M.toast({
              html: "No se pudo crear el excel",
              classes: "rounded",
              displayLength: 3000,
            });
          });
    },
    isRecharge(movimiento){
      const date = new Date()
      const rechargeProgramDateArray = movimiento.rechargeProgramDate.split('/')
      const movimientoDate = new Date(`${rechargeProgramDateArray[1]}/${rechargeProgramDateArray[0]}/${rechargeProgramDateArray[2]}`)

      if(movimiento.hasBeenRecharged != 1 && movimientoDate <= date)
        return true
      return false
    },
    recharge(movimiento){
      this.isGettingReports = false;
      checkoutProgramadas(movimiento).then(()=>{
        M.toast({
          html: "Recarga realizada con éxito",
          classes: "rounded",
          displayLength: 5000,
        });
        this.consultar()
      }).catch(error =>{
        return M.toast({
          html: `No fue posible realizar la recarga ${error. mensaje}`,
          classes: "rounded",
          displayLength: 5000,
        });
      })
    },
    dateIni() {
      const elem = document.getElementById("input-fecha-inicial");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
      console.log("wea");
    },
    dateFin() {
      const elem = document.getElementById("input-fecha-final");
      const instance = M.Datepicker.getInstance(elem);
      instance.open();
    },
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    handleFocusOut(llave) {
      const inputId = "input-" + llave;
      const input = document.getElementById(inputId);
      input.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "Enter",
            code: "Enter",
            keyCode: 13,
            which: 13,
          })
      );
    },
    initChips() {
      this.titulos.forEach((titulo) => {
        const elems = document.getElementById(titulo.llave);
        console.log(elems, `llega aqui`)
        const chipsOptions = {
          ...this.chipsOptions,
          key: titulo.llave,
          placeholder: `${titulo.valor}`,
        };
        const chip = M.Chips.init(elems, chipsOptions);
      });

    },
    deleteChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips = this.chips.filter(
          (c) => !(c.key === key && c.value === value)
      );
      console.log(this.chips);
    },
    addChip(a, b) {
      const key = a[0].M_Chips.options.key;
      const value = b.firstChild.textContent;
      this.chips.push({key, value});
      console.log(this.chips);
    },
    init() {
      this.$nextTick(() => {
        setTimeout(() => {
          M.AutoInit();
          this.initChips();
          const fechaInicialInput = document.querySelector(
              "#input-fecha-inicial"
          );
          const fechaFinalInput = document.querySelector("#input-fecha-final");

          M.Datepicker.init(fechaInicialInput, {
            format: "yyyy/mm/dd",
            i18n: i18n,
            onClose: () => {
              // Llama a consultar cuando se cierra el datepicker de fecha inicial
              this.consultar();
            },
          });

          M.Datepicker.init(fechaFinalInput, {
            format: "yyyy/mm/dd",
            i18n: i18n,
            onClose: () => {
              // Llama a consultar cuando se cierra el datepicker de fecha final
              this.consultar();
            },
          });

          M.updateTextFields();

        }, 1000);
      });
    },
    consultar() {
      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();

      if (!fechaIni) {
        const date = new Date();
        const mes =
            date.getDate() - 10 <= 0
                ? date.getMonth() <= 0
                ? 12
                : date.getMonth()
                : date.getMonth() + 1;
        fechaIni = `${
            date.getDate() - 10 <= 0 && date.getMonth() - 1 < 0
                ? date.getFullYear() - 1
                : date.getFullYear()
        }/${mes}/${
            date.getDate() - 10 <= 0
                ? 28 + date.getDate() - 10
                : date.getDate() - 10
        }`;

          document.getElementById("input-fecha-inicial").value = fechaIni;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()}`;

          document.getElementById("input-fecha-final").value = fechaFin;
      }
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const auxLider =
          this.usuarioSeleccionado === "0" ? undefined : this.usuarioSeleccionado;
      const auxPlataforma =
          this.plataforma === "0" ? undefined : this.plataforma;
      this.encontrados = "Cargando ...";
      filtros = {};
      /*  this.titulos = []; */
      this.datosAMostrar = [];
      this.datosRecibios = [];
      this.movimientos = [];
      this.isGettingReports = true;
      console.log(diaIni, mesIni, anioIni, diaFin, mesFin, anioFin);

        console.log(`estamos aqui en la mierda`)
      getProgramadas(
            diaIni,
            mesIni,
            anioIni,
            diaFin,
            mesFin,
            anioFin,
            auxLider,
            auxPlataforma
        )
            .then((respuesta) => {
              this.datosRecibios = [];
              this.datosAMostrar = [];
              respuesta.recargas = respuesta.recargas.map(r=>{
                const rechargeProgramDateArray = r.rechargeProgramDate.split('/')
                return {
                  ...r,
                  rechargeProgramDate : `${rechargeProgramDateArray[1]}/${rechargeProgramDateArray[0]}/${rechargeProgramDateArray[2]}`
                }
              })
              console.timeEnd("Reportes nuevo");
              console.log(respuesta.recargas.length, respuesta);
              this.isGettingReports = false;

              const hoy = new Date()

              const dia = String(hoy.getDate()).padStart(2, '0')
              const mes = String(hoy.getMonth() + 1).padStart(2, '0')
              const anio = hoy.getFullYear()

              const fechaFormateada = `${dia}/${mes}/${anio}`;
              const dataChipTotal = respuesta.recargas.filter(r => r.rechargeProgramDate.includes(fechaFormateada))
              const dataChipsRecargas = dataChipTotal.filter(r => r.rechargeDate != 'Sin Recarga')
              const dataChipsMesaje = `${fechaFormateada} <br>
              Total: ${dataChipTotal.length}<br>
              Recargadas: ${dataChipsRecargas.length}<br>
              Sin Recarga: ${dataChipTotal.length - dataChipsRecargas.length}`
              M.toast({
                html: dataChipsMesaje,
                classes: "rounded",
                displayLength: 20000000,
              })
              this.datosRecibios = this.datosRecibios.concat(
                  respuesta.recargas.slice()
              );
              this.datosAMostrar = this.datosAMostrar.concat(
                  respuesta.recargas.slice()
              );
              this.titulos.forEach((titulo) => (filtros[titulo.llave] = ""));
              this.numeroDeFilas = this.datosRecibios.length;
              this.encontrados = `${this.datosAMostrar.length} encontrados`;

              $(".input-filtros").prop("disabled", false);
            })
            .catch((error) => {
              console.log(error)
              M.toast({
                html: error.mensaje,
                classes: "rounded",
                displayLength: 20000,
              });
              this.isGettingReports = false;
              console.log(error);
            });
      }
    },
    generarExcel() {
      console.log("por generar excel ");
      let fechaIni = document
          .getElementById("input-fecha-inicial")
          .value.trim();
      let fechaFin = document.getElementById("input-fecha-final").value.trim();
      let diaIni, mesIni, anioIni, diaFin, mesFin, anioFin;
      console.log(fechaIni, fechaFin);
      if (!fechaIni) {
        const date = new Date();
        const mes =
            date.getDate() - 10 < 0
                ? date.getMonth() <= 0
                ? 12
                : date.getMonth()
                : date.getMonth() + 1;
        fechaIni = `${
            date.getDate() - 10 < 0 && date.getMonth() - 1 < 0
                ? date.getFullYear() - 1
                : date.getFullYear()
        }/${mes}/${
            date.getDate() - 10 < 0
                ? 30 + date.getDate() - 10
                : date.getDate() - 10
        }`;
      }
      if (!fechaFin) {
        const date = new Date();
        fechaFin = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()}`;
      }
      if (fechaIni.length > 2) {
        const fechaSeparada = fechaIni.split("/");
        diaIni = fechaSeparada[2];
        mesIni = fechaSeparada[1];
        anioIni = fechaSeparada[0];
      }
      if (fechaFin.length > 2) {
        const fechaSeparada = fechaFin.split("/");
        diaFin = fechaSeparada[2];
        mesFin = fechaSeparada[1];
        anioFin = fechaSeparada[0];
      }
      const fechas = {
        diaIni,
        mesIni,
        anioIni,
        diaFin,
        mesFin,
        anioFin,
      };
      const auxLider =
          this.usuarioSeleccionado === "0" ? undefined : this.usuarioSeleccionado;
      const auxPlataforma =
          this.plataforma === "0" ? undefined : this.plataforma;
      if (auxPlataforma) this.chips.plataforma = auxPlataforma;
      this.$store.commit("ponerBarra");
      console.log(this.chips, `estos son`);
      creaExcelCam(this.chips, "VENTAS", fechas)
          .then((response) => {
            this.$store.commit("quitarBarra");

              window.location = `https://recargasasec.com/excel?nombre=${response.data.nombreArchivo}`;

            delete filtros.fechaFinal;
            delete filtros.fechaInicial;
          })
          .catch((error) => {
            this.$store.commit("quitarBarra");
            console.log(error);
            M.toast({
              html: "No se pudo crear el excel",
              classes: "rounded",
              displayLength: 3000,
            });
            delete filtros.fechaFinal;
            delete filtros.fechaInicial;
          });
    },

}
</script>

<style scoped>
.datepicker {
  border-bottom: none !important;
}
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
  both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}
.wobble-hor-bottom:hover {
  -webkit-animation: pulsate-fwd 0.5s ease-in-out infinite both;
  animation: pulsate-fwd 0.5s ease-in-out infinite both;
}
@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.titulo {
  font-size: 2.2em;
  display: block;
  margin-top: 5px;
  font-family: "Roboto Thin", serif;
}

.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}

.icono-izquierda {
  left: 0;
}

.row {
  padding: 1rem;
}

.mensaje-error {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-family: "Roboto", serif;
  color: #b80009;
}

.radios {
  margin-left: 9%;
}

[type="radio"]:not(:checked) + span,
[type="radio"]:checked + span {
  float: left;
  color: black;
  font-size: 1.5em;
  margin-bottom: 8px;
}

td,
th {
  padding: 10px 5px;
}
.barraMovimientos {
  max-width: 100%;
  position: relative;
}
.btn-large {
  max-width: 100%;


  margin-bottom: 0.7rem;
}

.input-date {
  margin: 0.7rem 0 0 0;
}

.encontrados {
  font-size: 1.2rem;
}
table {
  font-size: 0.9rem;
}
.table-responsive {
  display: block;
  overflow-x: auto;
  width: 100%;
  text-align-last: center;
}
.icc-table {
  font-size: 0.75rem;
}

td {
  padding: 8px 3px;
}

@media (max-width: 800px) {
  table {
    font-size: 0.8rem;
  }

  th {
    height: 63px;
    max-height: 63px;
  }
  td {
    height: 63px;
    max-height: 63px;
  }

  .titulo {
    font-size: 2rem;
  }
}
</style>